import request from '@/utils/request';

const baseURL = process.env.VUE_APP_API;

// 获取token
const ssoLogin = params =>
  request({
    url: `${baseURL}/api/Common/SSOLogin`,
    method: 'get',
    params
  });

// 获取当前用户
const getCurrentUser = () =>
  request({
    url: `${baseURL}/api/Common/GetCurrentUser`,
    method: 'get'
  });

// 加密生成token
const createToken = () =>
  request({
    url: `${baseURL}/api/Common/CreateToken`,
    method: 'post'
  });

export default {
  ssoLogin,
  getCurrentUser,
  createToken
};
